//Taken from https://github.com/SamirHodzic/ngx-embed-video until they repackage properly for Angular 6

import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class EmbedVideoService {
  public videoRegex = new RegExp(
    '[^\\s]*(youtube.com|youtu.be|vimeo.com|dailymotion.com|dai.ly|web.microsoftstream.com)[^\\s]*',
    'i'
  );

  constructor(private sanitizer: DomSanitizer) {}

  public embed(body: any): any {
    let id;
    let playlist;

    var match = body.match(this.videoRegex);
    if (match) {
      body = match[0];
      // Add 'https://' if the original body does not start with 'http://' or 'https://'.
      if (!(body.toLowerCase().indexOf('http://') === 0 || body.toLowerCase().indexOf('https://') === 0)) {
        body = 'https://' + body;
      }
    }
    try {
      var url = new URL(body);

      id = this.detectYoutube(url);
      if (id) {
        playlist = body.indexOf('playlist') >= 0;
        return this.embed_youtube(id, playlist);
      }

      id = this.detectVimeo(url);
      if (id) {
        return this.embed_vimeo(id);
      }

      id = this.detectDailymotion(url);
      if (id) {
        return this.embed_dailymotion(id);
      }

      id = this.detectMicrosoftStream(url);
      if (id) {
        return this.embed_microsoftStream(id);
      }
      return null;
    } catch (ex) {
      return null;
    }
  }

  public embed_youtube(id: string, isPlaylist?: boolean): string {
    if (isPlaylist) {
      return this.sanitize_iframe(
        '<iframe src="https://www.youtube.com/embed/videoseries?list=' +
          id +
          '"' +
          ' frameborder="0" allowfullscreen></iframe>'
      );
    } else {
      return this.sanitize_iframe(
        '<iframe src="https://www.youtube.com/embed/' + id + '"' + ' frameborder="0" allowfullscreen></iframe>'
      );
    }
  }

  public embed_vimeo(id: string): string {
    return this.sanitize_iframe(
      '<iframe src="https://player.vimeo.com/video/' +
        id +
        '"' +
        ' frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'
    );
  }

  public embed_dailymotion(id: string): string {
    return this.sanitize_iframe(
      '<iframe src="https://www.dailymotion.com/embed/video/' + id + '"' + ' frameborder="0" allowfullscreen></iframe>'
    );
  }

  public embed_microsoftStream(id: string): string {
    return this.sanitize_iframe(
      '<iframe src="https://web.microsoftstream.com/embed/video/' +
        id +
        '?autoplay=false&amp;showinfo=true" allowfullscreen style="border:none;"></iframe>'
    );
  }

  private sanitize_iframe(iframe: string): any {
    return this.sanitizer.bypassSecurityTrustHtml(iframe);
  }

  private detectVimeo(url: any): string {
    return url.hostname === 'vimeo.com' ? url.pathname.split('/')[1] : null;
  }

  private detectYoutube(url: any): string {
    if (url.hostname.indexOf('youtube.com') > -1) {
      let id = url.search.split('=')[1];
      id = id.split('&')[0];
      return id;
    }

    if (url.hostname === 'youtu.be') {
      return url.pathname.split('/')[1];
    }

    return '';
  }

  private detectDailymotion(url: any): string {
    if (url.hostname.indexOf('dailymotion.com') > -1) {
      return url.pathname.split('/')[2].split('_')[0];
    }

    if (url.hostname === 'dai.ly') {
      return url.pathname.split('/')[1];
    }

    return '';
  }

  private detectMicrosoftStream(url: any): string {
    if (url.hostname.indexOf('web.microsoftstream.com') > -1) {
      if (url.pathname.split('/')[1] === 'video') {
        return url.pathname.split('/')[2];
      } else if (url.pathname.split('/')[2] === 'video') {
        return url.pathname.split('/')[3];
      }
    }
    return '';
  }
}
